import angular from 'angular';

angular.module('vrm.components').controller('UpdateDeviceController', UpdateDeviceController);

const STAGE_DONE = 1;
const STAGE_UPLOAD_FIRMWARE = 3;
const STAGE_TRIGGER_UPDATE = 4;
const STAGE_MIGRATE_SETTINGS = 5;
const STAGE_SYSTEM_UPDATING = 6;
const STAGE_CONFIGURE_SYSTEM = 7;

const STAGE_STATUS_GOOD = 1;
const STAGE_STATUS_WARN = 2;
const STAGE_STATUS_ERROR = 3;

/**
 * @property {number} status
 * @property {boolean} active
 * @property {boolean} done
 */
class FirmwareUpdateStage {
    constructor(code, label) {
        this.code = code;
        this.label = label;
        this.reset();
    }

    reset() {
        this.status = STAGE_STATUS_GOOD;
        this.active = false;
        this.done = false;
    }

    get css() {
        if (this.status === STAGE_STATUS_ERROR) {
            return 'state--error';
        } else if (this.status === STAGE_STATUS_WARN) {
            return 'state--warning';
        } else if (this.done) {
            return 'state--done';
        }
        return '';
    }

    get icon() {
        if (this.status !== STAGE_STATUS_GOOD) {
            return 'sg-vrm-icon_012_alarm-32px';
        } else if (this.done) {
            return "sg-vrm-icon_054_check-16px";
        } else if (!this.active && !this.done) {
            return "sg-vrm-icon_105_circle-16px vrm-pending";
        }
    }

    get isStatusGood() {
        return this.status === STAGE_STATUS_GOOD;
    }
}

/* @ngInject */
function UpdateDeviceController($scope, close) {
    /** @type FirmwareUpdateStage[] */
    $scope.stages = [
        new FirmwareUpdateStage(STAGE_UPLOAD_FIRMWARE, 'firmware-update.update-device-states.upload-firmware'),
        new FirmwareUpdateStage(STAGE_TRIGGER_UPDATE, 'firmware-update.update-device-states.trigger-update'),
        new FirmwareUpdateStage(STAGE_MIGRATE_SETTINGS, 'firmware-update.update-device-states.migrate-settings'),
        new FirmwareUpdateStage(STAGE_SYSTEM_UPDATING, 'firmware-update.update-device-states.system-updating'),
        new FirmwareUpdateStage(STAGE_CONFIGURE_SYSTEM, 'firmware-update.update-device-states.configure-system'),
    ];

    $scope.$watch('vrm_update_status', vrm_update_status => {
        if (!vrm_update_status) return;
        const { stage_code, stage_status } = vrm_update_status;

        const activeStageIndex = (stage_code === STAGE_DONE) ? $scope.stages.length : $scope.stages.findIndex(stage => stage.code === stage_code);
        $scope.stages.forEach((stage, index) => {
            stage.done = (index < activeStageIndex);
            stage.active = (index === activeStageIndex);

            if (stage.active) {
                stage.status = stage_status;
            }
        });
    });

    return {
        close,
    };
}
